import { useState } from 'react'
import { Segmented, Field, Button } from '../ds/index.js'

const TYPE_OPTIONS = [
  { key: 'note', label: 'Note' },
  { key: 'call', label: 'Call' },
  { key: 'meeting', label: 'Meeting' },
]

// Compose a timeline entry. onAdd({type, body}) fires on submit with a trimmed
// non-empty body, then the field clears.
export default function ActivityComposer({ onAdd }) {
  const [type, setType] = useState('note')
  const [body, setBody] = useState('')
  const submit = () => {
    const text = body.trim()
    if (!text) return
    onAdd({ type, body: text })
    setBody('')
  }
  return (
    <div style={{ border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-md)', padding: 10, marginBottom: 14 }}>
      <div style={{ marginBottom: 8 }}>
        <Segmented value={type} onChange={setType} options={TYPE_OPTIONS} size="sm" />
      </div>
      <Field as="textarea" rows={2} placeholder="Add a note…" value={body}
        onChange={(e) => setBody(e.target.value)} style={{ width: '100%' }} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
        <Button type="button" size="sm" onClick={submit}>Add</Button>
      </div>
    </div>
  )
}
